export default __webpack_public_path__ + "static/media/spacer-block-thumbnail-light.131ee499.svg";